import { render, staticRenderFns } from "./testPaper.vue?vue&type=template&id=06d7c4b5&scoped=true"
import script from "./testPaper.vue?vue&type=script&lang=js"
export * from "./testPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d7c4b5",
  null
  
)

export default component.exports